<template>
  <v-app>
    <template v-if="authorized">
      <div v-if="!sideBarHidden">
        <side-bar></side-bar>
      </div>
      <v-content class="grey-bg">
        <loading-indicator></loading-indicator>
        <div v-show="searchBarActive">
          <search-bar :archived="searchIsArchived" :path="$route.path"></search-bar>
        </div>
        <router-view></router-view>
      </v-content>
    </template>
    <template v-else>
      <div v-show="searchBarActive">
        <search-bar :archived="searchIsArchived" :path="$route.path"></search-bar>
      </div>
      <v-content class="blue-bg">
          <router-view></router-view>
      </v-content>
    </template>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SideBar from '@/components/_layouts/SideBar'
import SearchBar from '@/components/workorders/SearchBar'
import LoadingIndicator from '@/components/_layouts/LoadingIndicator'
export default {
  name: 'App',
  data: () => ({
    searchBarActive: false,
    searchIsArchived: false,
    sideBarHidden: false,
  }),
  components: {
    SideBar,
    SearchBar,
    LoadingIndicator
  },
  mounted () {
    this.authorized && this.sessionCheck()
    if (this.$route.path === '/work-orders' || this.$route.path === '/calendar') {
      this.searchBarActive = true
      this.searchIsArchived = false
    } else if (this.$route.path === '/work-orders/archived') {
      this.searchBarActive = true
      this.searchIsArchived = true
    } else {
      this.searchBarActive = false
    }
  },
  watch: {
    $route: function () {
      if (this.$route.path === '/work-order/task-manager/checklist') {
        this.sideBarHidden = true
      } else {
        this.sideBarHidden = false
      }
      // Check if given route is true, if it is then hide searchbar.
      if (this.$route.path === '/work-orders' || this.$route.path === '/calendar') {
      this.searchBarActive = true
      this.searchIsArchived = false
    } else if (this.$route.path === '/work-orders/archived') {
      this.searchBarActive = true
      this.searchIsArchived = true
    } else {
      this.searchBarActive = false
    }
    }
  },
  methods: {
    ...mapActions({
      sessionCheck: 'auth/sessionCheck'
    })
  },
  computed: {
    ...mapGetters({
      authorized: 'auth/isAuthorized'
    })
  }
}
</script>
<style>
  .blue-bg {
    background-color: #1e345d;
  }
  .grey-bg {
    background-color: #f3f3f6;
  }
  .title-block {
    color: #fff;
  }
</style>
